export default "__VITE_ASSET__83aeea79__"